/**
 * Enum representation of the days in a week starting with Sunday as 0 right up to Saturday as 6.
 */
export enum DayOfWeek {
  SUNDAY = 0,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}
